import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import gaming from '../assest/products/extra/gaming.jpg';
import business from '../assest/products/extra/business.jpg';
import twoinone from '../assest/products/extra/2in1.jpg';
import ultra from '../assest/products/extra/ultrabook.jpg';
import desk from '../assest/products/extra/desktop.jpg';

const CategorySlider = () => {

  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const categories = [
    { name: "Gaming", img: gaming, query: "gaming" },
    { name: "Business", img: business, query: "business" },
    { name: "2-in-1", img: twoinone, query: "2in1" },
    { name: "Ultrabook", img: ultra, query: "ultrabook" },
    { name: "Desktops", img: desk, query: "desktops" },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 mt-10">

      {/* 🔥 TITLE */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl md:text-3xl font-bold">
          Shop by Category
        </h2>

        <span className="text-sm text-gray-500 cursor-pointer hover:text-black">
          View All →
        </span>
      </div>

      {/* 💻 DESKTOP */}
      {!isMobile && (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">

          {categories.map((cat, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -8 }}
              transition={{ duration: 0.3 }}
              onClick={() => navigate(`/product-category?category=${cat.query}`)}
              className="relative h-[200px] rounded-2xl overflow-hidden cursor-pointer group shadow-lg"
            >

              {/* IMAGE */}
              <img
                src={cat.img}
                alt={cat.name}
                className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
              />

              {/* 🔥 OVERLAY */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

              {/* 🔥 SHINE EFFECT */}
              <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-20 transition" />

              {/* 🔥 TEXT */}
              <div className="absolute bottom-4 left-4 right-4">

                <p className="text-white text-lg font-semibold">
                  {cat.name}
                </p>

                <span className="text-xs text-gray-300">
                  Explore →
                </span>

              </div>

            </motion.div>
          ))}

        </div>
      )}

      {/* 📱 MOBILE */}
      {isMobile && (
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2500 }}
          loop
          spaceBetween={14}
          slidesPerView={1.3}
        >
          {categories.map((cat, i) => (
            <SwiperSlide key={i}>

              <motion.div
                whileTap={{ scale: 0.95 }}
                onClick={() => navigate(`/product-category?category=${cat.query}`)}
                className="relative h-[160px] rounded-xl overflow-hidden shadow-md"
              >

                <img
                  src={cat.img}
                  className="w-full h-full object-cover"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

                <div className="absolute bottom-3 left-3">
                  <p className="text-white font-semibold text-base">
                    {cat.name}
                  </p>
                </div>

              </motion.div>

            </SwiperSlide>
          ))}
        </Swiper>
      )}

    </div>
  );
};

export default CategorySlider;